import React, { useState, useEffect, useRef } from 'react';
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import moment from 'moment';
import placeHolder from '../../../assets/images/PlaceHolder.webp';
import Toast from '../../Shared/Toast/Toast';
import { apiBase } from '../../../utils/config';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { Dialog } from 'primereact/dialog';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

const AddEditAcademicCalender = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const importFileUploadRef = useRef(null);
    const [formData, setFormData] = useState({
        academicYearName: "",
        academicYearNameErr: false,
        academicYearNameErrText: '',
        calendarTemplateValues: [
            {
                dateRange: null,
                dateRangeErr: false,
                dateRangeErrText: '',
                classesApplicable: [],
            }
        ],
        importURL: "",
        importFile: null,
    });
    const [classList, setClassList] = useState([]);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);

     const academicYearNameRef = useRef(null);
            useEffect(() => {
                const loginData = CommonConfig.loginData();
                setSecurityUserID(loginData?._id);
        
                // Ensure focus after modal renders
                setTimeout(() => {
                    academicYearNameRef.current?.focus();
                }, 100);
            }, []);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetClassList(loginData?._id);
        if (props?.configId) {
            let formatedCalendar = props?.masterData?.CalendarValue?.map((x) => {
                return {
                    dateRange: [x?.StartDate ? new Date(x?.StartDate) : null, x?.EndDate ? new Date(x?.EndDate) : null], classesApplicable: x?.ApplicableClass?.split(',') || []
                }
            });
            formatedCalendar = formatedCalendar.length ? formatedCalendar : [{
                dateRange: null,
                dateRangeErr: false,
                dateRangeErrText: '',
                classesApplicable: [],
            }]
            setFormData((prev) => ({ ...prev, academicYearName: props?.masterData?.TitleName, importURL: props?.masterData?.ImportUrl, importFile: props?.masterData?.ImportFile ? `${apiBase}/Documents/${props?.masterData?.ImportFile}` : null, calendarTemplateValues: formatedCalendar }));
        }
    }, []);

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const GetClassList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let classData = res?.data?.filter(x => x?.Status === 'Active')?.map((x) => ({
                        value: x?._id,
                        label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`
                    }));
                    setClassList(classData);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const validate = () => {
        let formIsValid = true;
        const [startDate, endDate] = formData?.dateRange || [];
        if (CommonConfig.isEmpty(formData?.academicYearName)) {
            formIsValid = false;
            setFormData((prev) => ({ ...prev, academicYearNameErr: true, academicYearNameErrText: 'Name is required' }));
        } else {
            setFormData((prev) => ({ ...prev, academicYearNameErr: false, academicYearNameErrText: '' }));
        }

        const updatedCalendarValues = formData.calendarTemplateValues.map((item) => {
            const dateRange = item.dateRange;
            let dateRangeErr = false;
            let dateRangeErrText = '';

            if (!dateRange || !dateRange[0]) {
                formIsValid = false;
                dateRangeErr = true;
                dateRangeErrText = 'Start date is required';
            } else if (!dateRange[1]) {
                formIsValid = false;
                dateRangeErr = true;
                dateRangeErrText = 'End date is required';
            } else if (new Date(dateRange[0]).getTime() === new Date(dateRange[1]).getTime()) {
                formIsValid = false;
                dateRangeErr = true;
                dateRangeErrText = "'Start' and 'End' date cannot be the same";
            } else if (new Date(dateRange[0]) > new Date(dateRange[1])) {
                formIsValid = false;
                dateRangeErr = true;
                dateRangeErrText = "'Start' date cannot be after 'End' date";
            }

            return {
                ...item,
                dateRangeErr,
                dateRangeErrText
            };
        });

        setFormData((prev) => ({
            ...prev,
            calendarTemplateValues: updatedCalendarValues
        }));

        return formIsValid;
    };

    const onCancel = () => {
        props.onCancel();
    }
    const handleInputChange = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
    };

    const AddUpdateTemplate = async (e) => {
        if (validate(e)) {
            try {
                const dataForm = new FormData();
                dataForm.append("id", props?.masterData?._id ?? '');
                dataForm.append("TitleName", formData?.academicYearName);
                const formatedValue = formData?.calendarTemplateValues?.map(x => {
                    const [startDate, endDate] = x?.dateRange || [];
                    return {
                        StartDate: startDate ? moment(startDate).format("YYYY-MM-DD") : '',
                        EndDate: endDate ? moment(endDate).format("YYYY-MM-DD") : '',
                        ApplicableClass: x?.classesApplicable?.length > 1 ? x?.classesApplicable?.join(',') : x?.classesApplicable[0]
                    }
                })
                dataForm.append("CalendarValue", JSON.stringify(formatedValue));
                dataForm.append("ImportUrl", formData?.importURL);
                dataForm.append("CreatedBy", securityUserID);
                if (formData?.importFile && formData?.importFile.type) {
                    dataForm.append("ImportFile", formData?.importFile);
                }
                Loader.show();
                await api
                    .post(APIConstant.path.AddUpdateAcademicCalander, dataForm, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            // onCancel();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Toast.error({ message: err?.data?.message });
                        Loader.hide();
                        // onCancel();
                    });
            } catch (err) {
                console.log(err);
                Toast.error({ message: err });
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        } else {
            Toast.error({ message: "bfsdjkfdskj" });
        }
    };

    const handleFileUpload = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {
                setFormData((prev) => ({ ...prev, importFile: selectedFile }));
                const fileURL = URL.createObjectURL(selectedFile);
                setFormData((prev) => ({ ...prev, previewImportFile: fileURL }));
            };
            img.onerror = () => {
                if (importFileUploadRef.current) {
                    importFileUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };

            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);

        }
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    setFormData((prev) => ({ ...prev, previewImportFile: '', importFile: '' }));
                    if (importFileUploadRef.current) {
                        importFileUploadRef.current.clear();
                    }
                }}
            />
        </div>
    );

    const getDateOnly = (date) => {
        if (!date) return null;
        const d = new Date(date);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    const handleClassChange = (index, value) => {
        setFormData((prev) => {
            const updatedCalendarTemplateValues = [...prev.calendarTemplateValues];
            updatedCalendarTemplateValues[index] = {
                ...updatedCalendarTemplateValues[index],
                classesApplicable: value
            };

            return {
                ...prev,
                calendarTemplateValues: updatedCalendarTemplateValues
            };
        });
    };

    const handleDateRangeChange = (index, value) => {
        let [startDate, endDate] = value || [];
        startDate = getDateOnly(startDate);
        endDate = getDateOnly(endDate);

        setFormData((prev) => {
            const updated = [...prev.calendarTemplateValues];

            if (startDate && endDate) {
                if (startDate > endDate) {
                    updated[index] = {
                        ...updated[index],
                        dateRange: value,
                        dateRangeErr: true,
                        dateRangeErrText: "'Start' date cannot be after 'End' date."
                    };
                } else if (startDate.getTime() === endDate.getTime()) {
                    updated[index] = {
                        ...updated[index],
                        dateRange: value,
                        dateRangeErr: true,
                        dateRangeErrText: "'Start' and 'End' date cannot be the same."
                    };
                } else {
                    updated[index] = {
                        ...updated[index],
                        dateRange: value,
                        dateRangeErr: false,
                        dateRangeErrText: ''
                    };
                }
            } else {
                updated[index] = {
                    ...updated[index],
                    dateRange: value
                };
            }

            return {
                ...prev,
                calendarTemplateValues: updated
            };
        });
    };

    const dateBodyTemplate = (rowData, { rowIndex }) => {
        return (
          <div className="custom-inputs">
                <Calendar
                    id="dateRange"
                    value={rowData?.dateRange}
                    onChange={(e) => handleDateRangeChange(rowIndex, e.value)}
                    selectionMode="range"
                    readOnlyInput
                    dateFormat="dd/mm/yy"
                    className="p-w-100"
                    showButtonBar
                    placeholder='Select Date Range'
                />
                <span className="error-msg" style={{ color: 'red' }}>
                    {rowData?.dateRangeErr ? rowData?.dateRangeErrText : null}
                </span>
            </div>
        )
    };

    const classBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div className="custom-inputs">
                <MultiSelect
                    id="classesApplicable"
                    value={rowData?.classesApplicable}
                    options={classList}
                    onChange={(e) => handleClassChange(rowIndex, e.value)}
                    placeholder="Select Classes"
                    display="chip"
                    className='p-w-100'
                    filter
                />
            </div>
        )
    };

    const addCalenderValue = () => {
        const newValue = {
            dateRange: null,
            dateRangeErr: false,
            dateRangeErrText: '',
            classesApplicable: []
        };

        setFormData((prev) => ({
            ...prev,
            calendarTemplateValues: [...(prev.calendarTemplateValues || []), newValue]
        }));
    };

    const removeCalendarValue = (index) => {
        setFormData((prev) => {
            const updated = [...(prev.calendarTemplateValues || [])].filter((_, i) => i !== index);
            return {
                ...prev,
                calendarTemplateValues: updated
            };
        });
    };

    const actionsBodyTemplate = (rowData, { rowIndex }) => (
        <div className="p-d-flex p-jc-start">
            {rowIndex === formData?.calendarTemplateValues.length - 1 &&
                <Button
                    icon="pi pi-plus"
                    className="e-sction-btn p-m-0 p-m-2"
                    onClick={() => addCalenderValue()}
                />}
            {(rowIndex !== 0 || formData?.calendarTemplateValues.length > 1) &&
                <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-2"
                    onClick={() => removeCalendarValue(rowIndex)}
                />
            }
        </div>
    );

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div className='p-grid'>
                <div className="p-col-12 p-md-4 p-pt-2">
                   <div className="custom-inputs">
                        <label htmlFor="academicYearName">Academic Year Name</label>
                        <div className="custom-inputs">
                            <InputText
                            ref={academicYearNameRef}
                                id="academicYearName"
                                value={formData?.academicYearName}
                                maxLength={15}
                                className='p-mt-1'
                                onChange={(e) => handleInputChange("academicYearName", e.target.value)}
                                style={{
                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                }}
                            />
                            <span className="error-msg" style={{ color: 'red' }}>
                                {formData?.academicYearNameErr ? formData?.academicYearNameErrText : null}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="custom-inputs">
                        <label htmlFor="importURL">Import URL</label>
                        <div className="custom-inputs p-w-100">
                            <InputText
                                className='p-w-100 p-mt-1'
                                id="importURL"
                                value={formData.importURL}
                                onChange={(e) => handleInputChange("importURL", e.target.value)}
                                style={{
                                    fontFamily: "Noto Sans, Arial, sans-serif"
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div>
                        <label htmlFor="importFile">Import File</label>
                        <div className="p-d-flex p-flex-column p-jc-around">
                            <img src={formData?.previewImportFile || formData?.importFile || placeHolder} alt="" className="upload-preview" style={{ width: '200px', height: '150px', borderRadius: '8px', objectFit: 'cover' }} />
                            <div className='p-d-flex p-ai-center user-profile-btn p-mt-3'>
                                {!formData?.previewImportFile && <FileUpload ref={importFileUploadRef} name='importFile' customUpload auto mode="basic" uploadHandler={handleFileUpload} className="small-file-upload" accept="image/*" />
                                }
                                {(!CommonConfig.isEmpty(formData?.importFile) || !CommonConfig.isEmpty(formData?.previewImportFile)) && (
                                    <div
                                        className="error-msg-alert p-ml-2"
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            setIsDeleteConfirmation(true);
                                        }}
                                    >
                                        <i className="pi pi-trash" style={{ fontSize: "16px", color: "red" }}></i>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='e-grade-master-table p-w-100'>
                    <DataTable value={formData?.calendarTemplateValues} responsiveLayout="scroll" className="main-table table-td">
                        <Column header="Date Range" body={dateBodyTemplate} />
                        <Column header="Class" body={classBodyTemplate} />
                        <Column header="Actions" body={actionsBodyTemplate} />
                    </DataTable>
                </div>
            </div>
            <div className='dialog-footer p-d-flex p-ai-center p-jc-end'>
                <Button className='p-m-0 btn-text-action-secondary p-m-1' onClick={(e) => onCancel()}> Cancel </Button>
                <Button className='p-m-0 btn-text-action-primary' label="Submit" severity="secondary" raised onClick={(e) => AddUpdateTemplate()} />
            </div>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>

    );
};

export default AddEditAcademicCalender;
